import { Badge, Grid } from '@percent/lemonade'
import { dayJS } from '@percent/cause-dashboard/common/utility/date'
import { useTranslation } from 'react-i18next'

import styles from '../../PayoutsPage.module.scss'
import { PayoutDetailsProps } from './PayoutDetails.types'
import { currencyMapToFormat } from '@percent/cause-dashboard/common/utility/money/currencyMap'

export function PayoutDetails({ data, currencyMap }: PayoutDetailsProps) {
  const { t } = useTranslation()

  const moneyFormat = currencyMapToFormat(currencyMap)

  return (
    <div className={styles.detailsWrapper}>
      <Grid className={styles.detailsHeadersWrapper}>
        <Grid.Col span={3}>{t('typography.youReceived')}</Grid.Col>
        <Grid.Col span={2}>{t('typography.status')}</Grid.Col>
        <Grid.Col span={2}>{t('typography.payoutsTablePayoutDate')}</Grid.Col>
      </Grid>
      <Grid className={styles.detailsInfoWrapper}>
        <Grid.Col span={3} data-testid="grossDonationValue">
          {data ? moneyFormat({ amount: data.paidAmount, currency: data.paidCurrencyCode }) : null}
        </Grid.Col>
        <Grid.Col span={2} data-testid="statusValue">
          <Badge variant="positive" icon="approve">
            {t('typography.paid')}
          </Badge>
        </Grid.Col>
        <Grid.Col span={2} data-testid="payoutDateValue">
          {data?.paidAt ? dayJS(data.paidAt).format('DD MMM YYYY') : null}
        </Grid.Col>
      </Grid>
    </div>
  )
}
